@use "../../../../../globals/settings";
@use "../../../../../globals/bcp";

f-profile-flyout-user-bar {
  .profile-bar-item {
    display: flex;
    align-items: center;
    gap: bcp.nSpace(2);

    &__user {
      flex-grow: 2;
      // fix unknown width of flex container
      min-width: 0;

      .user-name {
        @include bcp.text-overflow(2);
        display: block;
        font-weight: bold;
      }

      .user-email {
        @include bcp.text-s;
        @include bcp.text-overflow();
        display: block;
      }
    }

    &__initials {
      .user-initials {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        padding: 12px;
        width: 48px;
        aspect-ratio: 1;
        box-sizing: border-box;
        background-color: #7dbcfe;
      }
    }
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
